export const toggleswitchTheme = {
  colorScheme: {
    light: {
      root: {
        width: '3.5rem',
        height: '1.5rem'
      },
      handle: {
        size: '1.3rem'
      }
    },
    dark: {
      root: {
        width: '3.5rem',
        height: '1.5rem'
      },
      handle: {
        size: '1.3rem'
      }
    }
  }
};
